<template>

  <div>

    <l-geo-json :geojson="geoJSON"
                :options="options.polygons"
                :options-style="style.polygons"
                @ready="geoJSONReady"
    >
    </l-geo-json>

  </div>

</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { centroid, centerOfMass, pointOnFeature, intersect, feature, polygon } from '@turf/turf';
import { DivIcon, GeoJSON, PolyUtil } from 'leaflet';

import LayerMixin from './Layer.Mixin';

const name = 'ServiceAreasLayer';

export default {

  name,

  mixins: [LayerMixin],

  props: {

    features: {
      type: Array,
      required: false,
      default: null,
    },

    color: {
      type: String,
      required: false,
    },

    displayLabels: {
      type: Boolean,
      required: false,
      default: false,
    },

  },

  data() {
    return {
      map: null,
      layer: null,
      tipVisible: false,
      labels: [],
      options: {
        polygons: {},
        labels: {},
      },
      style: {
        polygons: {
          color: this.color || this.$vuetify.theme.themes.light.info,
          fill: false,
        },
        labels: {
          color: 'transparent',
          fill: false,
        },
      },
    };
  },

  watch: {

    geoJSON(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.layer.bringToBack();
        this.centerWithinMap();
      }
    },

    $route() {
      this.centerWithinMap();
    },

  },

  computed: {

    geoJSON() {
      const data = this.features || this.$store.getters.serviceAreas;
      return data.filter(i => i.properties.Location !== 'Regional Service')
    },

    selectedService() {
      return this.$store.getters.selectedService;
    },

  },

  methods: {

    geoJSONReady(geoJSON) {
      this.layer = geoJSON;
      this.layer.bringToBack();
      this.map = geoJSON._map;
      this.map.invalidateSize();
    },

    handleMoveEnd(e) {
      if (e.target.getZoom() > 9) {
        this.map.invalidateSize();
        this.addLabels(e.target);
      }
    },

    addLabels(map) {
      this.throttled.cancel();
      this.labels = [];
      const bounds = map.getBounds().pad(-0.025);
      const coordinates = GeoJSON.latLngsToCoords([
        bounds.getSouthWest(),
        bounds.getNorthWest(),
        bounds.getNorthEast(),
        bounds.getSouthEast(),
        bounds.getSouthWest(),
      ]);

      const geoJSONBounds = polygon([coordinates]);

      this.geoJSON.forEach(feature => {
        let intersection = null;
        if (feature.geometry.type === 'MultiPolygon') {
          let i = 0;
          while (!intersection) {
            intersection = intersect(geoJSONBounds, polygon(feature.geometry.coordinates[i]));
            i += 1;
          }
        } else {
          intersection = intersect(geoJSONBounds, feature);
        }

        if (intersection) {
          const center = pointOnFeature(intersection);
          this.labels.push({
            properties: feature.properties,
            latLngs: GeoJSON.coordsToLatLng(center.geometry.coordinates, 1),
            intersection: GeoJSON.coordsToLatLngs(intersection.geometry.coordinates, intersection.geometry.type === 'Polygon' ? 1 : 2),
          });
        }
      });
    },

    centerWithinMap() {
      if (this.layer && this.map && !this.selectedService) {
        this.layer.bringToBack();
        this.$nextTick(() => {
          this.map.flyToBounds(this.layer.getBounds());
        });
      }
    },

    goToProvider(feature) {
      const route = {
        name: 'provider-detail',
        params: {
          id: feature.properties.ProviderID,
        },
        query: {
          service: feature.properties.OBJECTID,
        }
      };
      this.$router.push(route);
    },

  },

};
</script>
